import { TopSection } from "src/components/_pages/personal-policy/top-section";
import { TextSection } from "src/components/_pages/personal-policy/text-section";
import { Footer } from "src/components/footer";

const PersonalPolicy = () => {
  return (
    <>
      <title>石巻マリンヴィレッジ | PERSONAL POLICY</title>
      <article>
        <TopSection />
        <TextSection />
        <Footer />
      </article>
    </>
  );
};

export default PersonalPolicy;
